import {
  DatasetSearchModeEnum,
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch, Input_Template_UserChatInput } from '../input';
import { Output_Template_Finish } from '../output';

export const KnowledgeBaseModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.knowledgeBase,
  templateType: ModuleTemplateTypeEnum.logicDeal,
  flowType: FlowNodeTypeEnum.knowledgeBase,
  avatar: '/imgs/module/db.png',
  name: '知识库搜索',
  description: '根据输入内容，从知识库搜索相关知识',
  isTool: true,
  inputs: [
    Input_Template_Switch,
    {
      key: ModuleInputKeyEnum.knowledgeSelectList,
      type: FlowNodeInputTypeEnum.selectedKnowledgeBase,
      label: '知识库',
      value: [],
      valueType: ModuleIOValueTypeEnum.string,
      list: [],
      required: true,
      showTargetInApp: false,
      showTargetInPlugin: true,
    },
    {
      key: ModuleInputKeyEnum.knowledgeSearchMode,
      type: FlowNodeInputTypeEnum.select,
      label: '搜索模式',
      valueType: ModuleIOValueTypeEnum.string,
      showTargetInApp: false,
      showTargetInPlugin: false,
      value: DatasetSearchModeEnum.mixedRecall,
      required: true,
      list: [
        { label: '语义搜索', value: DatasetSearchModeEnum.embedding },
        { label: '混合搜索', value: DatasetSearchModeEnum.mixedRecall },
        { label: '全文搜索', value: DatasetSearchModeEnum.fullTextRecall },
      ],
    },
    {
      key: ModuleInputKeyEnum.knowledgeMaxRows,
      type: FlowNodeInputTypeEnum.numberInput,
      label: '引用条数上限',
      description: '引用内容的最大条数',
      value: 5,
      required: true,
      valueType: ModuleIOValueTypeEnum.number,
      showTargetInApp: false,
      showTargetInPlugin: false,
      min: 0,
    },
    {
      key: ModuleInputKeyEnum.knowledgeMaxTokens,
      type: FlowNodeInputTypeEnum.numberInput,
      label: '引用字数上限',
      description: '引用内容的最大字数',
      value: 2000,
      required: true,
      valueType: ModuleIOValueTypeEnum.number,
      showTargetInApp: false,
      showTargetInPlugin: false,
      min: 0,
    },
    {
      key: ModuleInputKeyEnum.knowledgeSimilarity,
      type: FlowNodeInputTypeEnum.numberInput,
      label: '引用最低相关度',
      description: '引用内容的最低相关度',
      valueType: ModuleIOValueTypeEnum.boolean,
      showTargetInApp: false,
      showTargetInPlugin: false,
      value: false,
    },
    {
      ...Input_Template_UserChatInput,
      toolDescription: '需要检索的内容',
    },
  ],
  outputs: [
    Output_Template_Finish,
    {
      key: ModuleOutputKeyEnum.knowledgeIsEmpty,
      label: '知识搜索为空',
      type: FlowNodeOutputTypeEnum.source,
      valueType: ModuleIOValueTypeEnum.boolean,
      targets: [],
    },
    {
      key: ModuleOutputKeyEnum.knowledgeUnEmpty,
      label: '知识搜索不为空',
      type: FlowNodeOutputTypeEnum.source,
      valueType: ModuleIOValueTypeEnum.boolean,
      targets: [],
    },
    {
      key: ModuleOutputKeyEnum.knowledgeResults,
      label: '从知识库中搜索到的结果',
      type: FlowNodeOutputTypeEnum.source,
      valueType: ModuleIOValueTypeEnum.datasetQuote,
      targets: [],
    },
  ],
};
